import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa'; // Importing FaTimes from react-icons

const ImageZoom = ({ src, alt }) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const handleZoom = () => {
    setIsZoomed(true);
  };

  const handleClose = () => {
    setIsZoomed(false);
  };

  return (
    <div className="relative">
      {/* Container for the image */}
      <img
        onClick={handleZoom}
        className="w-full skeleton rounded-md showAnimation h-auto cursor-pointer object-cover"
        src={src}
        alt={alt}
      />

      {/* Zoomed image */}
      {isZoomed && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <button
            className="absolute top-4 right-4 bg-white text-black rounded-full p-2 focus:outline-none"
            onClick={handleClose}
          >
            <FaTimes className="h-6 w-6" />
          </button>
          <img
            className="max-w-full showAnimation skeleton  max-h-full object-contain shadow-lg"
            src={src}
            alt={alt}
          />
        </div>
      )}
    </div>
  );
};

export default ImageZoom;
